/**
 * Injected-turn signal — bridges server-injected user turns (persisted
 * elsewhere, announced via `conversation.message_added`, appended by
 * `useAgentRunEvents`) to the scroll-anchoring machinery.
 *
 * A composer send arms the viewport pin through `thread.runStart`; an
 * injected turn (credential-continuation SYSTEM NOTE, inbox answer) never
 * fires that event, so the pin either stayed in a stale half-armed state
 * (the 2026-08 convergence-storm trigger) or ignored the new turn entirely.
 * `useAgentRunEvents` raises this signal just before appending, and
 * `AnchoredViewport` arms the pin exactly as it does for runStart — the
 * injected chip pins to the top of the viewport and the continuation
 * response streams in below it, matching the user-message model.
 *
 * Scoped by conversationId so a signal never arms the pin of an unrelated
 * mounted thread (operator + builder panes can coexist).
 */

type Listener = (conversationId: string) => void;

const listeners = new Set<Listener>();

export function onInjectedUserTurn(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function signalInjectedUserTurn(conversationId: string): void {
  for (const listener of listeners) listener(conversationId);
}
